import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import PrivateCASLRoute from "../../components/PrivateCASLRoute";
import IntlMessages from "../../util/IntlMessages";
import NotFound from "../../containers/NotFound";
import { useIntl } from "react-intl";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { Result } from "antd";
import { MobileOutlined } from "@ant-design/icons";
import { getAdminPath, lazyWithRetry } from "../../util/router";
import { ACLSubject } from "../../constants/Enums";
import { isEmpty } from "lodash";
import ErrorBoundary from "../../components/ErrorBoundary";

//Lazy loading
const Dashboard = lazy(() => import("./dashboard"));

//Popolazione
const Requests = lazyWithRetry(() => import("./popolazione/requests"));
const InputTracks = lazyWithRetry(() => import("./popolazione/input-tracks"));
const InputTrackUpdate = lazyWithRetry(() =>
   import("./popolazione/input-tracks/update/index")
);
const OutputTracks = lazyWithRetry(() => import("./popolazione/output-tracks"));

//Risorse
const IncomeRequests = lazyWithRetry(() => import("./risorse/requests"));
const IncomeInputTracks = lazyWithRetry(() => import("./risorse/input-tracks"));
const IncomeInputTrackUpdate = lazyWithRetry(() =>
   import("./risorse/input-tracks/update/index")
);
const IncomeOutputTracks = lazyWithRetry(() => import("./risorse/output-tracks"));

const Users = lazyWithRetry(() => import("./users"));
const UserInsert = lazyWithRetry(() => import("./users/insert"));
const UserUpdate = lazyWithRetry(() => import("./users/update"));
const ProfileSettings = lazyWithRetry(() => import("./profile-settings"));
const Settings = lazyWithRetry(() => import("./settings"));
const Debug = lazyWithRetry(() => import("./debug"));

const Api = lazyWithRetry(() => import("./api"));
const ApiInsert = lazyWithRetry(() => import("./api/insert"));
const ApiUpdate = lazyWithRetry(() => import("./api/update"));

//Databases
const Banks = lazy(() => import("./databases/banks"));

const Admin = () => {
   const intl = useIntl();

   const screens = useBreakpoint();

   //isEmpty per assicurarsi che screens sia valorizzato altrimenti inizialmente a vuoto mostra per una microfrazione il componente.
   if (!isEmpty(screens) && !screens.md) {
      return (
         <Result
            icon={<MobileOutlined />}
            status="warning"
            title={intl.formatMessage({ id: "common.viewport_error" })}
         />
      );
   }

   return (
      <ErrorBoundary>
         <Suspense fallback={<IntlMessages id="common.loading" />}>
            <Switch>
               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.USER}
                  exact
                  path={getAdminPath("dashboard")}
                  component={Dashboard}
               />
               <Route
                  exact
                  path={getAdminPath("profile")}
                  component={ProfileSettings}
               />

               {/* ANAGRAFICA */}
               <Route exact path={getAdminPath("requests")} component={Requests} />

               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.INPUT_TRACK}
                  exact
                  path={getAdminPath("input-tracks")}
                  component={InputTracks}
               />

               <PrivateCASLRoute
                  I="update"
                  a={ACLSubject.INPUT_TRACK}
                  exact
                  path={getAdminPath("input-tracks/update/:itemId")}
                  component={InputTrackUpdate}
               />

               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.OUTPUT_TRACK}
                  exact
                  path={getAdminPath("output-tracks")}
                  component={OutputTracks}
               />

               {/* RISORSE */}

               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.INCOME_REQUEST}
                  exact
                  path={getAdminPath("incomes/requests")}
                  component={IncomeRequests}
               />

               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.INCOME_INPUT_TRACK}
                  exact
                  path={getAdminPath("incomes/input-tracks")}
                  component={IncomeInputTracks}
               />

               <PrivateCASLRoute
                  I="update"
                  a={ACLSubject.INCOME_INPUT_TRACK}
                  exact
                  path={getAdminPath("income-input-tracks/update/:itemId")}
                  component={IncomeInputTrackUpdate}
               />

               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.INCOME_OUTPUT_TRACK}
                  exact
                  path={getAdminPath("incomes/output-tracks")}
                  component={IncomeOutputTracks}
               />

               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.USER}
                  exact
                  path={getAdminPath("databases/banks")}
                  component={Banks}
               />

               {/* ADMIN */}
               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.USER}
                  exact
                  path={getAdminPath("settings")}
                  component={Settings}
               />
               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.USER}
                  exact
                  path={getAdminPath("debug")}
                  component={Debug}
               />
               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.USER}
                  exact
                  path={getAdminPath("users")}
                  component={Users}
               />
               <PrivateCASLRoute
                  I="create"
                  a={ACLSubject.USER}
                  exact
                  path={getAdminPath("users/insert")}
                  component={UserInsert}
               />
               <PrivateCASLRoute
                  I="update"
                  a={ACLSubject.USER}
                  exact
                  path={getAdminPath("users/update/:itemId")}
                  component={UserUpdate}
               />

               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.API_SETTING}
                  exact
                  path={getAdminPath("api")}
                  component={Api}
               />
               <PrivateCASLRoute
                  I="create"
                  a={ACLSubject.API_SETTING}
                  exact
                  path={getAdminPath("api/insert")}
                  component={ApiInsert}
               />
               <PrivateCASLRoute
                  I="update"
                  a={ACLSubject.API_SETTING}
                  exact
                  path={getAdminPath("api/update/:itemId")}
                  component={ApiUpdate}
               />

               <Route path="*" component={NotFound} />
            </Switch>
         </Suspense>
      </ErrorBoundary>
   );
};

export default Admin;
